import {
  FormFields,
  PersonalDetailsFormFields,
  StepInfo,
} from 'components/EmployeeOnboarding/ContractorSelfOnboarding/types';
import { routePaths } from 'components/Routes/data';
import { KycFormFields } from './types';

export const steps: StepInfo[] = [
  {
    id: 'kyc-info',
    title: 'KYC',
    step: 1,
    route: routePaths.employeeOnboarding.contractorSelfOnboarding.kycDetails,
  },
  {
    id: 'bank-details',
    title: 'Bank Details',
    step: 2,
    route: routePaths.employeeOnboarding.contractorSelfOnboarding.bankDetails,
  },
  {
    id: 'personal-details',
    title: 'Personal Details',
    step: 3,
    route: routePaths.employeeOnboarding.contractorSelfOnboarding.personalDetails,
  },
  {
    id: 'review-details',
    title: 'Review Details',
    step: 4,
    route: routePaths.employeeOnboarding.contractorSelfOnboarding.reviewDetails,
  },
];

export const routeToStepMap = steps.reduce((acc, step) => {
  acc[step.route] = step.step;
  return acc;
}, {} as Record<string, number>);

export const kycFormInitialData: KycFormFields = {
  pan: '',
  aadharNumber: '',
  verificationConsent: false,
};

export const personalFormInitialData: PersonalDetailsFormFields = {
  phoneNumber: '',
  enableWhatsapp: false,
  gender: [],
  dob: null,
};

export const formInitialData: FormFields = {
  ...kycFormInitialData,
  ...personalFormInitialData,
};

//query and mutation keys
export const GET_SELF_ONBOARDING_CONTRACTOR_DATA = 'GET_SELF_ONBOARDING_CONTRACTOR_DATA';
